import { useParams, Link } from "react-router-dom";
import React, { useState, useEffect } from "react";
import ReactPlayer from "react-player";
import axios from "axios";
import ammy from "./CategoryVideos.module.css";

export default function CategoryVideos() {
  const { id } = useParams(); // category_id
  const categoryId = Number(id);

  const [videos, setVideos] = useState([]);

  // Fetch API
  const fetchVideos = async () => {
    try {
      const response = await axios.get(
        "https://ke-kiddzmania.rashigames.com/api/fetch-product"
      );

      const allVideos = response.data.videos || [];

      // FILTER BY CATEGORY
      const categoryVideos = allVideos.filter(
        (v) => v.category_id === categoryId
      );

      setVideos(categoryVideos);
    } catch (error) {
      console.error("API Error:", error);
    }
  };

  useEffect(() => {
    fetchVideos();
  }, [categoryId]);

  return (
    <div className={ammy.page}>
      <Link to="/" className={ammy.backBtn}>
        ← Back to Home
      </Link>

      <h2 className={ammy.heading}>Category Videos</h2>

      <div className={ammy.grid}>
        {videos.length > 0 ? (
          videos.map((video) => (
            <div key={video.id} className={ammy.card}>
              <ReactPlayer
                src={video.video_src}
                controls
                width="100%"
                height="140px"
               
              />
              <h4>{video.name}</h4>

              <Link to={`/video/${video.id}`}>
                <button className={ammy.watchBtn}>Watch</button>
              </Link>
            </div>
          ))
        ) : (
          <p>No videos found for this category.</p>
        )}
      </div>
    </div>
  );
}
